import React, { useState } from 'react'
import { validarPin, isSuccess } from "../api";
import { int, isEmpty } from '../utils';
import { Button, Form, Message, Modal } from 'semantic-ui-react';



export default ({ visible, toggle, onClick, tieneMotivo }) => {
  const [pin, setPin] = useState('')
  const [motivo, setMotivo] = useState('')
  const [error, setError] = useState(false)
  const [busy, setBusy] = useState(false)
  
  const onChange =(e) => setPin(e.target.value)
  const onMotivo = (e)  => setMotivo(e.target.value)
  const continuar = async () => {
    try {
      setError(false)
      setBusy(true)
      const numPin = int(pin)
      const res = await validarPin(numPin)
      if (isSuccess(res) && res.data) {
        await onClick(numPin, motivo)
        toggle()
      } else {
        setError(true)
      }
    } catch (e) {
      console.error(e)
      setError(true)
    } finally {
      setBusy(false)
    }
  }

  const disabled = busy || isEmpty(pin) || (tieneMotivo && isEmpty(motivo))

  return (
    <Modal open={visible} onClose={toggle} onOpen={toggle}  size="small">
      <Modal.Header>Autorizacion</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.Input id="pin_clave" autoComplete="off" value={pin} onChange={onChange} label="Ingresa el código de acceso" type="password" required disabled={busy} />
            {tieneMotivo &&
              <Form.TextArea id="motivo" value={motivo} onChange={onMotivo} label="Ingresa un motivo" required disabled={busy} />
            }
          </Form>
        </Modal.Description>
        {error && <CodigoInvalido />}
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={toggle} content="Volver" />
        <Button content="Continuar" onClick={continuar} positive loading={busy} disabled={disabled} />
      </Modal.Actions>
    </Modal>
  )
}

const CodigoInvalido = () => (
  <Message negative>
    <Message.Header>Error de autorización</Message.Header>
    <p>El código ingresado no es valido</p>
  </Message>
)